import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { translate } from 'services/i18nService';
import Button from 'components/Button/Button';
import { generateID } from 'utils/helpers';
import iconDone from 'images/icon-done.png';

import styles from './TwoFaModal.css';


function Success(props) {
  const { closeModal, ids } = props;

  const btnId = 'cashOutCloseButton';
  const makeId = generateID(ids.prefix, ids.element);

  return (
    <Fragment>
      <div className={styles.centredContent}>
        <img
          alt="Success icon"
          className={styles.checkImage}
          src={iconDone}
        />
        <h5 className={styles.boldText}>
          {translate('gifting.profile.gift.success')}
        </h5>
        <p>
          {translate('strings.strings.click.dismiss.message')}
        </p>
      </div>
      <div className={styles.successMsgFooter}>
        <Button id={makeId(btnId)} onClick={closeModal}>
          {translate('profile.profile.send.message.close')}
        </Button>
      </div>
    </Fragment>
  );
}

Success.propTypes = {
  closeModal: PropTypes.func.isRequired,
  ids: PropTypes.shape({
    element: PropTypes.string.isRequired,
    prefix: PropTypes.string.isRequired,
  }),
};

Success.defaultProps = { ids: {} };

export default Success;
